import { Box } from "@mui/material";
import SearchBar from "../../../components/SearchBar";
import { TableFilter, TableFilterOption } from "../TableFilter";
import Header from "../Header";
import { RenderToolbarProps } from "../TablePaginated/TablePaginated";

type Props = {
  title: string;
  subtitle?: string;
  newButtonLabel?: string;
  onNew?: () => void;
  onTriage?: () => void;
  onBack?: () => void;
  onFilter?: (option: TableFilterOption) => void;
  onBulkLaunch?: () => void;
};

export type TableToolbarStackedProps = Props & RenderToolbarProps;

export default function TableToolbarStacked({
  title,
  subtitle,
  newButtonLabel,
  searchQuery,
  onNew,
  onTriage,
  onBulkLaunch,
  onBack,
  onSearch,
  onSearchClear,
  onFilter
}: TableToolbarStackedProps) {
  return (
    <Box component="div" sx={{ backgroundColor: "#fff" }}>
      <Header
        title={title}
        subtitle={subtitle}
        newLabelName={newButtonLabel}
        onNew={onNew}
        onTriage={onTriage}
        onBack={onBack}
        onBulkLaunch={onBulkLaunch}
      />
      <SearchBar
        value={searchQuery}
        onChange={onSearch}
        clearSearch={onSearchClear}
      >
        {onFilter && <TableFilter defaultValue="ALL" onChange={onFilter} />}
      </SearchBar>
    </Box>
  );
}
